<template>
  <div>
    <Echart
      :options="options"
      id="centerRightChart"
      height="430px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';

export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  created() {},
  methods: {},
  watch: {
    cdata: {
      handler(newData) {
        // console.log(newData,'this.schoolData');

        let seriesArr = [];
        newData.yAxisDataArr.map((item) => {
          let seriesItem = {
            symbolSize: 7,
            name: item.seriesName,
            type: 'line',
            smooth: false,
            yAxisIndex: 0,
            data: item.seriesData,
            itemStyle: {
              normal: {
                borderWidth: 2
              }
            }
          };
          seriesArr.push(seriesItem);
        });

        this.options = {
          color: ['#159eca', '#b73750'],
          title: {
            text: '学校数据统计',
            left: 'center',
            textStyle: {
              fontSize: '26',
              color: '#fff',
              fontWeight: '300'
            }
          },
          grid: {
            left: '30',
            top: '100',
            bottom: '30',
            right: '10'
            // containLabel: true
          },
          legend: {
            type: 'scroll',
            right: '10',
            top: '60',
            data: newData.legends,
            itemWidth: 18,
            itemHeight: 12,
            textStyle: {
              fontSize: 14
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          yAxis: [
            {
              type: 'value',
              name: '学生数/人',
              position: 'left',
              max: newData.max,
              nameTextStyle: {
                color: '#ffffff',
                lineHeight: 30
              },
              splitLine: {
                show: true,
                lineStyle: {
                  // type: 'dashed',
                  color: '#31497A'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#31497A'
                }
              }
              // axisTick: {
              //   show: false
              // },
              // axisLabel: {
              //   formatter: '{value}',
              //   fontSize: 16
              // }
            },
            {
              // 右边框
              type: 'value',
              position: 'right',
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#31497A'
                }
              }
            }
          ],
          xAxis: [
            {
              type: 'category',
              // boundaryGap: false,
              axisTick: {
                show: false
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#31497A'
                }
              },
              axisLabel: {
                inside: false,
                textStyle: {
                  fontWeight: 'normal',
                  fontSize: '14',
                  lineHeight: 22
                }
              },
              data: newData.xAxisData
            }
          ],
          series: seriesArr
        };
      },
      // immediate: true,
      deep: true
    }
  }
};
</script>
